<div class="" [formGroup]="formGroup">
  <label [for]="name" class="mb-2 block font-theme-source text-base font-bold "
         [class.text-theme-black]="black"
         [class.text-white]="!black"
  >
    {{label}}
  </label>
  <input [formControlName]="name" [type]="type" [autocomplete]="autocomplete" [placeholder]="placeholder" [attr.aria-label]="label" id="{{name}}"
         enterkeyhint="next" [appFocusNextId]="appFocusNextId"
         [tabIndex]="tabIndex" [autofocus]="autoFocus"
         class="
  bg-white rounded-md py-[10px] px-5
  border-{{border}}
  text-theme-black font-theme-source placeholder:font-theme-source
  outline-none transition  disabled:cursor-default disabled:bg-gray-2 disabled:border-gray-2 w-full"
         [class.border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.border-theme-green]="formGroup.controls[name].valid && showValidationErrors"
         [class.active:border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.focus:border-theme-orange]="formGroup.controls[name].invalid && showValidationErrors"
         [class.active:border-theme-green]="formGroup.controls[name].valid && showValidationErrors"
         [class.focus:border-theme-green]="formGroup.controls[name].valid && showValidationErrors"

         [class.h-14]="big"
         [class.text-xl]="big"

         (change)="onChange.emit()"
  />
</div>

